// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"253":"dff1d685","341":"4bce6f19","377":"c6aa1f6d","438":"fb0cdf3e","706":"98bb0200","996":"86fc04da"}[chunkId] + ".chunk.js";
};